/**
 * Skeleton — lightweight shimmering placeholder.
 *
 * Use anywhere you'd otherwise render `null` or a spinner inside a
 * card. Keeps the layout stable while real data loads.
 */
import React from "react";

export default function Skeleton({ className = "", testid }) {
  return (
    <div
      className={`relative overflow-hidden rounded-md bg-black/[0.06] ${className}`}
      data-testid={testid}
    >
      <div
        className="absolute inset-0 -translate-x-full link-shimmer"
        style={{
          background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.55), transparent)",
        }}
      />
    </div>
  );
}
